<script setup lang="ts">

</script>

<template>
  <div class="blank-layout">
    <router-view />
  </div>
</template>

<style scoped>

</style>